import React from "react";
import { Button, Text, Box } from "@chakra-ui/react";
import { FaPlus } from "react-icons/fa";
import { usePersonalizacao } from "../../context/usePersonalizacao";

export function CardVerMais({onClickVerMais}) {
  const {personalizacao: {guiaofertas}} = usePersonalizacao();

  return (
    <Button
      display="flex"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      h="100%"
      w="204px"
      background="transparent"
      _hover={[{ opacity: 0.85 }]}
      _focus={[{ border: "none" }]}
      outline={false}
      onClick={onClickVerMais}
    >
      <Box
        background={guiaofertas.colortextvermais}
        width="64px"
        height="64px"
        borderRadius="full"
        display="flex"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
      >
        <FaPlus color="#FFF" size={24} />
      </Box>
      <Text
        color={guiaofertas.colortextvermais}
        fontSize="1.125rem"
        fontWeight="bold"
        marginTop="1.5rem"
      >
        Ver mais
      </Text>
    </Button>
  );
}
